import React, { useMemo } from 'react';

import { useAdminAiUsageStore } from '@dashboard/hooks/queries/useAdminQueries';

import Link from '@dashboard/components/Link';
import { Skeleton } from '@dashboard/components/ui/skeleton';

import AiBudgetForm from './AiBudgetForm';
import { AI_USAGE_PLAN_LABELS, aiUsageStoreHref } from './aiUsageLabels';
import { formatMicros, periodRange } from './aiUsagePeriod';

type AiUsageStoreData = {
  plan: string;
  budgetMicros: number;
  planBudgetMicros: number;
  overrideUsd: number | null;
  monthCostMicros: number;
};

const MerchantAiSection = ({ sellerId }: { sellerId: string }) => {
  const range = useMemo(() => periodRange('this-month'), []);
  const { data: store, isLoading } = useAdminAiUsageStore(sellerId, range) as {
    data?: AiUsageStoreData;
    isLoading: boolean;
  };

  return (
    <div>
      <h2 className="mb-4">AI</h2>
      <div className="space-y-4">
        {store ? (
          <>
            <div className="space-y-1 text-sm">
              <p>
                {`${formatMicros(store.monthCostMicros)} of ${formatMicros(store.budgetMicros)} this month (estimated)`}
              </p>
              <p className="text-gray-500 dark:text-muted-foreground">
                {`Plan: ${AI_USAGE_PLAN_LABELS[store.plan] ?? store.plan}`}
              </p>
            </div>
            <AiBudgetForm
              key={`${sellerId}-${store.overrideUsd}`}
              sellerId={sellerId}
              overrideUsd={store.overrideUsd}
              planBudgetMicros={store.planBudgetMicros}
            />
          </>
        ) : isLoading ? (
          <div className="space-y-2">
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-5 w-24" />
          </div>
        ) : (
          <p className="text-sm text-gray-500 dark:text-muted-foreground">
            Couldn't load AI usage.
          </p>
        )}
        <p className="text-sm">
          <Link to={aiUsageStoreHref(sellerId)}>Open AI usage</Link>
        </p>
      </div>
    </div>
  );
};

export default MerchantAiSection;
